import * as d3 from 'd3-geo';
import supervisorData from '../../../common/data/supervisor_data.json';

let supervisorGeoJsonPromise;
let assemblyGeoJsonPromise;

async function loadSupervisorGeoJson() {
  if (!supervisorGeoJsonPromise) {
    supervisorGeoJsonPromise = fetch('/districts/supdist_20250520.geojson').then((r) => r.json());
  }
  return supervisorGeoJsonPromise;
}

async function loadAssemblyGeoJson() {
  if (!assemblyGeoJsonPromise) {
    assemblyGeoJsonPromise = fetch('/districts/assembly-2022.geojson').then((r) => r.json());
  }
  return assemblyGeoJsonPromise;
}

function generateSupervisorData(districtNum) {
  const data = { ...supervisorData[districtNum.toString()] };
  if (!data) {
    return {};
  }
  data.districtNum = districtNum;
  data.staffEmail = data.lastName + 'staff@sfgov.org';
  data.email = `${data.firstName}.${data.lastName}@sfgov.org`;
  return data;
}

export async function supervisorByCoords(lat, lng) {
  const geoJson = await loadSupervisorGeoJson();
  const coords = [lng, lat];
  for (const feature of geoJson.features) {
    if (d3.geoContains(feature, coords)) {
      const label = feature.properties['sup_dist'] || feature.properties.DISTRICT;
      const num = parseInt(label, 10);
      if (!Number.isNaN(num)) {
        return generateSupervisorData(num);
      }
    }
  }
  return {};
}

export async function assemblyByCoords(lat, lng) {
  const geoJson = await loadAssemblyGeoJson();
  const coords = [lng, lat];
  for (const feature of geoJson.features) {
    if (d3.geoContains(feature, coords)) {
      const dist = feature.properties.GEOID || feature.properties['sup_dist'];
      return { district: dist };
    }
  }
  return {};
}

export function supervisorByDistrict(district) {
  return generateSupervisorData(parseInt(district, 10));
}

export async function districtInfoForCoords(lat, lng) {
  const [supervisor, assembly] = await Promise.all([
    supervisorByCoords(lat, lng),
    assemblyByCoords(lat, lng),
  ]);
  return { supervisor, assembly };
}
